import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { baseApi } from "api/BaseApi";
import { addRole } from "app/role.slice";
import { addUser } from "app/user.slice";

import "./MemberPortalSubheader.css";

export default function Subheader({ userName, selectedDashBoard }) {
  const [cookie, setCookie, removeCookie] = useCookies();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const memberPortalTitle = () => {
    if (selectedDashBoard === "Lab") {
      return "Lab";
    } else if (selectedDashBoard === "SME") {
      return "My";
    } else {
      return selectedDashBoard;
    }
  };

  const returnToSelf = async () => {
    dispatch(baseApi.util.resetApiState);

    const tempCookie = cookie["old_auth_token"];
    setCookie("auth_token", tempCookie, { path: "/" });
    removeCookie("old_auth_token", { path: "/" });
    const userData = await axios.get(
      `${import.meta.env.VITE_DJANGO_ENDPOINT}account/users/currentUser/`,
      {
        withCredentials: true,
        headers: { Authorization: `Token ${tempCookie}` },
      },
    );
    dispatch(addUser(userData.data));
    const roleData = await axios.get(
      `${import.meta.env.VITE_DJANGO_ENDPOINT}account/roles/getRole/`,
      {
        withCredentials: true,
        headers: { Authorization: `Token ${tempCookie}` },
      },
    );
    dispatch(addRole(roleData.data));
    navigate("/community/");
  };

  return (
    <Box
      className="subheader"
      sx={{ color: "white" }}
      p=".5em"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Box
        sx={{
          textAlign: "center",
          padding: 2,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="500"
          fontSize={20}
          mt={0.5}
          textTransform="uppercase"
        >
          {memberPortalTitle()} Dashboard
        </Typography>
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography
          variant="h1"
          fontWeight="700"
          fontSize={32}
          sx={{
            borderTop: "#f8c95a solid 5px",
          }}
          mb={0}
        >
          {userName ? `Welcome, ${userName}!` : "Welcome!"}
        </Typography>
      </Box>

      {cookie["old_auth_token"] && (
        <Box display={"flex"} alignItems="center">
          <Button
            variant="contained"
            color="error"
            onClick={returnToSelf}
            data-cy="end-emulation-button"
          >
            End Emulation
          </Button>
        </Box>
      )}
    </Box>
  );
}
